module.exports = __webpack_public_path__ + "img/yt-avaxusdc_usdc.588b025e.png";